import React from 'react';
import './EmptyState.css';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';

const EmptyState = ({ state, booksReading, booksWantToRead, booksRead }) => {
  const { t } = useTranslation();
  let quote;
  let author;
  let book;
  let message;
  let buttonText = t.emptyFindBook;
  if (booksRead > 0) {
    buttonText = t.emptyFindNewBook;
  }
  let link = '/search';
  let showButton = true;

  switch (state) {
    case 'reading':
      quote = t.emptyState.reading.quote;
      author = t.emptyState.reading.author;
      book = t.emptyState.reading.book;
      message = t.emptyReading;
      break;
    case 'wantToRead':
      quote = t.emptyState.wanttoread.quote;
      author = t.emptyState.wanttoread.author;
      book = t.emptyState.wanttoread.book;
      message = t.emptyWantToRead;
      break;
    case 'read':
      quote = t.emptyState.read.quote;
      author = t.emptyState.read.author;
      book = t.emptyState.read.book;
      message = booksReading > 0 ? t.emptyNoBookProgress : t.emptyNoBooks;
      showButton =
        booksReading + booksWantToRead + booksRead === 0 ? true : false;
      break;
    case 'stats':
      quote = t.emptyState.stats.quote;
      author = t.emptyState.stats.author;
      book = t.emptyState.stats.book;
      message = t.emptyStats;
      link = '/books';
      buttonText = t.emptyGoToBooks;
      break;
  }

  return (
    <div>
      <div key="quote" className="card">
        <div className="quote">{quote}</div>
        <div className="quoter">
          <div className="author">{author}</div>
          <div className="book">{book}</div>
        </div>
      </div>
      <div key="message" className="empty-state">
        <div className="pt-65">{message}</div>
        {showButton && (
          <Link to={link} className="btn btn-primary w-100">
            {buttonText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
